module.exports = __webpack_public_path__ + "img/privilege13.6231aa9f.png";